
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/bein-simasala",
      function () {
        return require("private-next-pages/um/thjonusta/bein-simasala.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/bein-simasala"])
      });
    }
  